var _style, _defs, _path, _defs2, _path2, _path3, _defs3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPocketTextLogo = function SvgPocketTextLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 693 183",
    style: {
      enableBackground: "new 0 0 693 183"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1,.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.st6{fill:#363636}")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145 40.939)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0.9,
    width: 96.6,
    height: 141.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.9,
    width: 96.6,
    height: 141.1,
    id: "pktlogorounded_rgb-b_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pktlogorounded_rgb-a_1_",
    className: "st1",
    d: "M0 .9h96.7V142H0z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M48.8 86.3c-19.3 0-35.5-16.3-35.5-36.2 0-20.1 16.1-36.8 35.5-36.8 19.7 0 35.5 16.7 35.5 36.8 0 19.9-15.8 36.2-35.5 36.2M49 1.7C34.4 1.7 21.4 9.9 12.2 21l-.3-13.2C11.7 3.2 9.4.9 6 .9 2.4.9 0 3.7 0 7.7v128c0 3.8 2.6 6.4 6.2 6.4 3.8 0 6-2.8 6-6.6v-56C21.4 90.4 34.4 97.9 49 97.9c26.6 0 47.7-21.4 47.7-47.8S75.7 1.7 49 1.7",
    style: {
      mask: "url(#pktlogorounded_rgb-b_1_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#363636"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m84.1 84.3-25.5 24c-1.3 1.5-3.4 2.1-4.9 2.1-1.9 0-3.8-.6-5.3-2.1l-25.1-24c-2.6-2.8-3-7.5 0-10.5 2.8-2.6 7.5-3 10.3 0l20.1 19.3 20.5-19.3c2.6-3 7.3-2.6 9.9 0 2.6 3 2.6 7.7 0 10.5M97 44.5H10.3C4.7 44.5 0 48.8 0 54.5v32.1c0 29.1 24 53.3 53.7 53.3 29.5 0 53.3-24.2 53.3-53.3V54.5c-.1-5.7-4.6-10-10-10",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ef4056"
    },
    transform: "translate(0 -1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(462 -.061)"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 0.3,
    y: 0.1,
    width: 73.8,
    height: 139.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.3,
    y: 0.1,
    width: 73.8,
    height: 139.1,
    id: "pktlogorounded_rgb-d_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_1_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pktlogorounded_rgb-c_1_",
    className: "st1",
    d: "M.3.1h73.8v139.1H.3z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m33.3 86.3 34.9-31.5c3.2-2.8 3.6-6.9 1.1-9.6-2.6-2.8-6.6-2.1-9.4.6L12.5 90.4V7.2c0-4.3-1.9-7.1-5.8-7.1C2.4.1.3 2.9.3 7.2V132c0 4.1 2.4 6.9 6.4 6.9 3.6 0 5.8-2.8 5.8-6.9v-27l12.2-11L63 136.7c2.4 2.6 6.6 3.6 9.2 1.1 3-2.8 2.1-6.6-.2-9.2L33.3 86.3z",
    style: {
      mask: "url(#pktlogorounded_rgb-d_1_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#363636"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M300.2 128.2c-19.3 0-35.5-16.3-35.5-36.2 0-20.1 16.1-36.8 35.5-36.8 19.7 0 35.5 16.7 35.5 36.8 0 19.9-15.8 36.2-35.5 36.2m.4-84.6c-27.2 0-48.2 22-48.2 48.4s21 47.8 48.2 47.8c25.5 0 47.7-21.4 47.7-47.8s-22.4-48.4-47.7-48.4",
    transform: "translate(0 -1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(632 17.939)"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 0.7,
    y: 0.3,
    width: 60,
    height: 120.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.7,
    y: 0.3,
    width: 60,
    height: 120.6,
    id: "pktlogorounded_rgb-f_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_2_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "pktlogorounded_rgb-e_1_",
    className: "st1",
    d: "M.7.3h60v120.6H.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 102.7c-1.9 0-3.8 1.1-4.9 2.1-2.6 2.3-5.8 4.5-10.3 4.5-7.7 0-12-4.7-12-15.4V36.1l23.8.4c3.4 0 5.6-2.1 5.6-5.3 0-3.4-2.3-5.4-5.6-5.4l-23.8.2V6.6c0-3.8-2.6-6.4-5.8-6.4-3.4 0-6.2 2.6-6.2 6.4V26l-10.2-.2c-3.2 0-5.4 2.1-5.4 5.4 0 3 2.4 5.4 5.4 5.3l10.1-.4v58.2c0 18.2 11.1 26.6 23.8 26.6 7.9 0 13.9-3 18-7.3 1.3-1.5 2.6-3.2 2.6-5.4.1-3.2-1.9-5.5-5.1-5.5",
    style: {
      mask: "url(#pktlogorounded_rgb-f_1_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#363636"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M552.3 85.2c2.8-19.7 17.3-30 33.7-30 17.4 0 29.6 14.6 30.4 30h-64.1zM586 43.6c-26.6 0-46.5 22-46.5 48.4s20.3 47.8 46.7 47.8c13.1 0 25.9-4.9 34.3-13.1 1.9-1.9 3.4-3.9 3.4-6 0-3-1.9-5.4-5.4-5.4-1.9 0-3.8.8-5.3 2.1-7.9 6.9-15.9 10.9-27 10.9-17.2 0-32.6-13.1-34.2-32.6h67c6.4 0 9.9-3.4 9.9-8.8 0-21.2-18.4-43.3-42.9-43.3zm-145.8 66.6c-1.7 0-3.6 1.3-4.7 2.8-5.3 6.9-16.5 15.2-29.1 15.2-18.8 0-34.9-14.8-34.9-36.2 0-22.9 16.1-36.6 34.9-36.6 13.7 0 21.2 6.6 27.6 14.3 1.1 1.3 2.8 2.6 4.9 2.6 2.8 0 5.6-2.1 5.6-4.9 0-2.1-1.3-4.1-2.4-5.8-7.7-11.1-20.6-17.4-35.6-17.4-26.1 0-47.5 21.4-47.5 47.8 0 26.1 21.4 47.8 47.5 47.8 16.1 0 30-9.4 37.3-19.1 1.3-1.7 2.1-3.4 2.1-4.9-.1-3.3-2.5-5.6-5.7-5.6",
    transform: "translate(0 -1)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPocketTextLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pocket-text-logo.fd3a2a9d0c6e986d2cf9f7a656fdea30.svg";